/* eslint-disable react/no-multi-comp */
import React from 'react';
import * as format from '@app/utils/formatters';
import MenuItemVerticalPopoverMenu from './MenuItemPopover';

const getFooter = (totals, accessor) => () =>
    totals?.[accessor] ? format.decimal(totals?.[accessor]) : null;

export default (
    totals,
    { editCampaign, deleteCampaign, currency },
    t?: (key: string) => string,
) => [
    {
        Header: t ? t('socialPostMetrics.columns.campaign') : 'Campaign',
        accessor: 'campaignName',
        Cell: ({ value }: { value: string }) => value,
        headerClassName: '--secondary',
        Footer: () => (t ? t('socialPostMetrics.total') : 'Total'),
        width: 200,
        format: value => value || '-',
    },
    {
        Header: t
            ? t('socialPostMetrics.columns.totalImpressions')
            : 'Total Impressions',
        accessor: 'impressions',
        Cell: ({ value }: { value: number }) => format.decimal(value),
        headerClassName: '--secondary',
        Footer: getFooter(totals, 'impressions'),
        format: value => (value ? format.decimal(value) : '-'),
    },
    {
        Header: t
            ? t('socialPostMetrics.columns.paidImpressions')
            : 'Paid Impressions',
        accessor: 'paidImpressions',
        Cell: ({ value }: { value: number }) => format.decimal(value),
        headerClassName: '--secondary',
        Footer: getFooter(totals, 'paidImpressions'),
        format: value => (value ? format.decimal(value) : '-'),
    },
    {
        Header: t ? t('socialPostMetrics.columns.videoViews') : 'Video Views',
        accessor: 'videoViews',
        Cell: ({ value }: { value: number }) => format.decimal(value),
        headerClassName: '--secondary',
        Footer: getFooter(totals, 'videoViews'),
        format: value => (value ? format.decimal(value) : '-'),
    },
    {
        Header: t ? t('socialPostMetrics.columns.engagements') : 'Engagements',
        accessor: 'engagements',
        Cell: ({ value }: { value: number }) => format.decimal(value),
        headerClassName: '--secondary',
        Footer: getFooter(totals, 'engagements'),
        format: value => (value ? format.decimal(value) : '-'),
    },
    {
        Header: t ? t('socialPostMetrics.columns.fmv') : 'FMV',
        accessor: 'fullMediaValue',
        Cell: ({ value }: { value: number }) =>
            format.currency(value, { currency }),
        headerClassName: '--secondary',
        Footer: () => format.currency(totals?.fullMediaValue, { currency }),
        format: value => (value ? format.currency(value, { currency }) : '-'),
    },
    {
        Header: t ? t('socialPostMetrics.columns.postCount') : 'Post Count',
        accessor: 'postCount',
        Cell: ({ value }: { value: number }) => format.decimal(value),
        headerClassName: '--secondary',
        Footer: getFooter(totals, 'postCount'),
        format: value => (value ? format.decimal(value) : '-'),
    },
    {
        Header: t
            ? t('socialPostMetrics.columns.dateModified')
            : 'Date Modified',
        accessor: 'addedAt',
        Cell: ({ value }: { value: string | Date | null }) => {
            if (!value) return '-';
            return format.shortDate(value);
        },
        headerClassName: '--secondary',
        format: value => (value ? format.shortDate(value) : '-'),
        defaultSortDesc: true,
    },
    {
        Header: '',
        accessor: 'id',
        id: 'actions',
        Cell: row => {
            const { campaignId: id } = row.original;

            return (
                <MenuItemVerticalPopoverMenu
                    id={id}
                    editCampaign={editCampaign}
                    deleteCampaign={deleteCampaign}
                />
            );
        },
        style: {
            overflow: 'visible',
        },
    },
];
